import { CellProps, Column } from 'react-table';
import { MenuItem, MenuLink } from '@reach/menu-button';
import { useRouter, useSref } from '@uirouter/react';

import { Environment } from '@/core/environments/types';
import { ActionsMenu } from '@/core/components/datatables/components/ActionsMenu';
import {
  snapshotEndpoint,
  trustEndpoint,
} from '@/core/environments/environment.service';
import * as notifications from '@/core/services/notifications';
import { getRoute } from '@/core/environments/utils';
import { confirmAsync } from '@/core/services/modal.service/confirm';
import { useRowContext } from '@/edge/devices/components/EdgeDevicesDatatable/columns/RowContext';

export const actions: Column<Environment> = {
  Header: 'Действия',
  accessor: () => 'actions',
  id: 'actions',
  disableFilters: true,
  canHide: true,
  disableResizing: true,
  width: '5px',
  sortType: 'string',
  Filter: () => null,
  Cell: ActionsCell,
};

export function ActionsCell({
  row: { original: environment },
}: CellProps<Environment>) {
  const router = useRouter();

  const environmentRoute = getRoute(environment);
  const browseLinkProps = useSref(environmentRoute, {
    id: environment.Id,
    endpointId: environment.Id,
  });

  const showRefreshSnapshot = false; // remove and show MenuItem when feature is available

  const { disableTrustOnFirstConnect } = useRowContext();

  return (
    <ActionsMenu>
      <MenuLink href={browseLinkProps.href} onClick={browseLinkProps.onClick}>
        Обзор
      </MenuLink>
      {showRefreshSnapshot && (
        <MenuItem hidden onSelect={() => handleRefreshSnapshotClick()}>
          Обновить снимок состояния
        </MenuItem>
      )}
      {disableTrustOnFirstConnect && !environment.UserTrusted && (
        <MenuLink onClick={trustDevice}>Доверять</MenuLink>
      )}
    </ActionsMenu>
  );

  async function handleRefreshSnapshotClick() {
    try {
      await snapshotEndpoint(environment.Id);
      notifications.success('Готово', 'Окружение обновлено');
    } catch (err) {
      notifications.error(
        'Ошибка',
        err as Error,
        'Не удалось создать снимок состояния окружения'
      );
    } finally {
      await router.stateService.reload();
    }
  }

  async function trustDevice() {
    const confirmed = await confirmAsync({
      title: '',
      message: `Отметить окружение «${environment.Name}» как доверенное?`,
      buttons: {
        cancel: {
          label: 'Отмена',
          className: 'btn-default',
        },
        confirm: {
          label: 'Доверять',
          className: 'btn-primary',
        },
      },
    });

    if (!confirmed) {
      return;
    }

    try {
      await trustEndpoint(environment.Id);
    } catch (err) {
      notifications.error(
        'Ошибка',
        err as Error,
        'Не удалось отметить окружение как доверенное'
      );
    } finally {
      await router.stateService.reload();
    }
  }
}
